// UserRoute.js
import React from "react";
import { useSelector } from "react-redux";
import LoadingToRedirect from "./LoadingToRedirect";

const UserRoute = ({ children }) => {
  const { user } = useSelector((state) => ({ ...state }));

  console.log("userRoute", user);

  // ถ้ายังไม่รู้ว่า user มี token ไหม (เช่นตอน refresh) → แสดง Loading ไปก่อน
  if (user === null) {
    return <p>Loading...</p>; // หรือ spinner
  }

  // ถ้ามี token แล้ว → ให้เข้าได้
  return user && user.token ? children : <LoadingToRedirect />;
};

export default UserRoute; // Export เป็น default
